export default __webpack_public_path__ + "static/media/20140928_163410.e397bdce-min.e0506b7f.jpg";